import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from 'react';
import { AuthService } from './authService';
const AuthContext = createContext(undefined);
export const AuthProvider = ({ children }) => {
    const [authState, setAuthState] = useState({
        isLoading: true,
        isAuthenticated: false,
        user: null,
        error: null,
    });
    // Initialize auth state on mount
    useEffect(() => {
        const initializeAuth = async () => {
            try {
                const user = await AuthService.validateToken();
                setAuthState({
                    isLoading: false,
                    isAuthenticated: !!user,
                    user: user || null,
                    error: null,
                });
            }
            catch (error) {
                console.error('Auth initialization error:', error);
                setAuthState({
                    isLoading: false,
                    isAuthenticated: false,
                    user: null,
                    error: 'Failed to initialize authentication',
                });
            }
        };
        initializeAuth();
    }, []);
    const login = async () => {
        const loginUrl = await AuthService.getLoginUrl();
        window.location.href = loginUrl;
    };
    const logout = () => {
        AuthService.clearAuth();
        setAuthState({
            isLoading: false,
            isAuthenticated: false,
            user: null,
            error: null,
        });
        const logoutUrl = AuthService.getLogoutUrl();
        window.location.href = logoutUrl;
    };
    const refreshUser = async () => {
        try {
            const user = await AuthService.validateToken();
            setAuthState({
                isLoading: false,
                isAuthenticated: !!user,
                user: user || null,
                error: null,
            });
        }
        catch (error) {
            console.error('User refresh error:', error);
        }
    };
    const value = {
        ...authState,
        login,
        logout,
        refreshUser,
    };
    return _jsx(AuthContext.Provider, { value: value, children: children });
};
export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within AuthProvider');
    }
    return context;
};
//# sourceMappingURL=authContext.js.map